
import { useEffect, useState } from 'react';
//import crypto from 'crypto-browserify';
import CryptoJS from 'crypto-js';


const ComplateOrder = () => {

    const [amount, setAmount] = useState('1'); 
    const [name, setName] = useState('Ravinder Kumar'); 
    const [email, setEmail] = useState('ravinderkumar@machwan.in'); 



        const handlePayment = (e : any) => { 
            
          e.preventDefault(); 
       
          const txnId = new Date().getTime(); // Unique transaction ID 
          
          const merchantKey = process.env.REACT_APP_PAYU_MERCHANTKEY;// 'aBQgZB'; 
          const salt = process.env.REACT_APP_PAYU_SALT;// 'VCG48Dfw'; 
          const hashString = merchantKey + "|" + txnId + "|" + amount + "|" + "MeripustakByPayU" + "|" + name + "|" + email + "|||||||||||" + salt;
          const _hash = CryptoJS.SHA512(hashString);

          type _paymentData = { 
            key: any; 
            txnid: any ;
            amount :  any ;
            productinfo : any;
            firstname : any;
            phone : any;
            email : any;
            surl : any;
            furl : any;
            hash : any;
        };

          const paymentData : _paymentData = { 
            key : merchantKey, 
            txnid: txnId, 
            amount : amount, 
            productinfo: `MeripustakByPayU`, 
            firstname: name, 
            phone : "9899677985",
            email : 'ravinderkumar@machwan.in', 
            surl : "http://localhost:3000?Status=success",
            furl : "http://localhost:3000?Status=fail",
            hash : _hash, 
            // Additional parameters as needed 
          }; 
       
          // Redirect to PayUMoney payment page 
          const form = document.createElement('form'); 
          form.method = 'POST'; 
          form.action = 'https://secure.payu.in/_payment'; // Use the live URL for production 
       
          Object.keys(paymentData).forEach( (key : any)=> { 
            //
            const _key: keyof _paymentData = key;
            const input = document.createElement('input'); 
            input.type = 'hidden'; 
            input.name = key; 
            input.value = paymentData[_key]; 
            form.appendChild(input); 
          }); 
       
          document.body.appendChild(form); 
          form.submit(); 
        }; 
       
    


    return (<>
    <div className=" breadcrumb-padding-180"></div>
      <input 
        type="text" 
        placeholder="Name" 
        value={name} 
        onChange={(e) => setName(e.target.value)} 
        required 
      /> 
      <input 
        type="email" 
        placeholder="Email" 
        value={email} 
        onChange={(e) => setEmail(e.target.value)} 
        required 
      /> 
      <input 
        type="number" 
        placeholder="Amount" 
        value={amount} 
        onChange={(e) => setAmount(e.target.value)} 
        required 
      /> 
      <button type="submit"  onClick={ e => handlePayment(e) } >Pay Now</button> 
    

    </>);
}

export default ComplateOrder;